// extracted by mini-css-extract-plugin
export default {"inner_bottom_left":"BottomBox_inner_bottom_left__QZoVB","inner_bottom_right":"BottomBox_inner_bottom_right__-cpsI"};